import { widgetverseUrl } from "$utils/urls";

export function setupWidget(communitySlug: string) {
  let widget = document.getElementById("ov-snippet");
  // check if the script is already loaded
  if (!widget) {
    widget = document.createElement("script");
    widget.setAttribute("src", widgetverseUrl({ communitySlug }));
    widget.setAttribute("id", "ov-snippet");
    document.head.appendChild(widget);

    // add onload handler
    widget.onload = function () {
      // do something with the script
      console.log("Script loaded");
      // @ts-ignore
    };
  }

  // unhide the iframe
  window.ov?.unhide();
  return widget;
}
